import { Clear, Send } from '@mui/icons-material';
import { Box, Grid, Typography, Button, TextField, Divider, useMediaQuery, useTheme } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { IUser, UserServices } from '../../../services/api/users/UserServices';
import { ICompany } from '../../../services/api/company/CompanyServices';

interface ResponsibleFormProps {
    initialData?: ICompany;
    showAlert: (message: string, severity: 'success' | 'error' | 'warning' | 'info') => void;
    navigateToCompanies: () => void;
}

export const ResponsibleForm = ({ initialData, showAlert, navigateToCompanies }: ResponsibleFormProps) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const { id } = useParams();
    const [error, setError] = useState<boolean>(false);
    const [data, setData] = useState<IUser>({
        email: '',
        login: '',
        nome: '',
        permissoes: 'add,edit,remove',
        nivel: 'empresa',
        main_user: true,
        ativo: true,
        notificacao: true,
        outsystem: false,
        nivel_acesso: {
            informacoes: {
                central: 'add,edit,remove,view',
                identificacao: 'add,edit,remove,view',
                caracterizacao: 'add,edit,remove,view',
                organograma: 'add,edit,remove,view',
            },
            documentacao_tecnica: {
                caracteristicas: 'add,edit,remove,view',
                arquivos: 'add,edit,remove,view',
            },
            registros: {
                RISR: 'add,edit,remove,view',
                RISROT: 'add,edit,remove,view',
                RISE: 'add,edit,remove,view',
                operacoes: 'add,edit,remove,view',
                monitoramento: 'add,edit,remove,view',
            },
            acompanhamentos: {
                comunicacao: 'add,edit,remove,view',
                visualizacao: 'add,edit,remove,view',
                inspecoes: 'add,edit,remove,view',
                anomalias: 'add,edit,remove,view',
                plano: 'add,edit,remove,view',
            },
            revisao: {
                RPSB: 'add,edit,remove,view',
            },
            PAE: {
                PAE: 'add,edit,remove,view',
                conformidades: 'add,edit,remove,view',
                treinamento: 'add,edit,remove,view',
                seminario: 'add,edit,remove,view',
                simulado: 'add,edit,remove,view',
                registro: 'add,edit,remove,view',
            },
        },
    });

    useEffect(() => {
        if (initialData != undefined && initialData.responsavel) {
            setData(initialData.responsavel);
            data.uuid = initialData.uuid;
        }
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...data, [name]: value };
        setData(updatedData);
    };

    function verify(data: IUser): boolean {
        return (
            data.nome !== '' &&
            data.email !== '' &&
            data.login !== '' &&
            data.senha !== ''
        );
    }

    const handleSave = () => {
        const valid = verify(data);
        valid == true ? setError(false) : setError(true);


        if (valid && id === 'novo' && data && initialData?.uuid) {
            UserServices.createResponsible(initialData?.uuid, data)
                .then(response => {
                    if (response instanceof Error) {
                        showAlert(response.message, 'error');
                    } else {
                        showAlert('Empresa cadastrada com sucesso!', 'success');
                        navigateToCompanies();
                    }
                });
        }
        if (valid && id !== 'novo' && id) {
            if (data?.uuid && data.permissoes) {
                UserServices.upgradeResponsible(data.uuid, data)
                    .then(response => {
                        if (response instanceof Error) {
                            showAlert(response.message, 'error');
                        } else {
                            showAlert('Dados atualizados com sucesso!', 'success');
                            navigateToCompanies();
                        }
                    });
            } else if (id && data) {
                UserServices.createResponsible(id, data)
                    .then(response => {
                        if (response instanceof Error) {
                            showAlert(response.message, 'error');
                        } else {
                            showAlert('Usuário cadastrada com sucesso!', 'success');
                            navigateToCompanies();
                        }
                    });
            }
        }
    };


    return (
        <Box width={'100%'}>
            <Grid container flex={1}>
                <Grid item xs={8}>
                    <Typography variant='h5'> Cadastro de responsavel</Typography>
                    <Typography variant='body2'> Empresa : {initialData?.company_name}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        variant='contained'
                        type='reset'
                        className='reset-button'
                        startIcon={<Clear />}
                        sx={{ borderRadius: '25px' }}
                    >Limpar</Button>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        variant='contained'
                        type="submit"
                        className="submit-button"
                        endIcon={<Send />}
                        sx={{ borderRadius: '25px' }}
                        onClick={handleSave}
                    // onClick={handleSaveClick}
                    >{id === 'novo' ? 'Proximo' : 'Salvar'}</Button>
                </Grid>
            </Grid>
            <Grid container flex={1} spacing={2} padding={1} marginTop={2}>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Nome'
                        type='text'
                        fullWidth
                        name='nome'
                        value={data.nome}
                        onChange={handleChange}
                        error={error && data.nome === ''}
                        helperText={error && data.nome === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Login'
                        type='text'
                        fullWidth
                        name='login'
                        value={data.login}
                        onChange={handleChange}
                        error={error && data.login === ''}
                        helperText={error && data.login === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                {initialData?.uuid ? <>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Senha'
                            type='password'
                            fullWidth
                            name='senha'
                            value={data.senha}
                            onChange={handleChange}
                            error={error && data.senha === ''}
                            helperText={error && data.senha === '' ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                </> : <>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Senha'
                            type='password'
                            fullWidth
                            name='senha'
                            value={data.senha}
                            onChange={handleChange}
                            error={error && data.senha === ''}
                            helperText={error && data.senha === '' ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                </>}
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        label='E-mail'
                        placeholder='email@exemplo.com'
                        value={data.email}
                        name='email'
                        onChange={handleChange}
                        error={error && data.email === ''}
                        helperText={error && data.email === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                {/* <Grid item xs={smDown ? 12 : 6} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <FormControlLabel
                        control={
                            <Switch
                                name="notificacao"
                                checked={data.notificacao}
                                onChange={handleSwitchChange}
                            />
                        }
                        label={'Receber notificação de '}
                    />
                </Grid> */}
                <Grid item xs={smDown ? 12 : 6}>
                    {/* <ReactInputMask
                            mask={'999.999.999-99'}
                            name='register'
                            onChange={handleChange}
                            value={data.register}
                        >
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                label='Documento'
                                name='register'
                            />
                        </ReactInputMask> */}
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Ramal'
                        type='number'
                        fullWidth
                        name='ramal'
                        value={data.ramal}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    {/* <ReactInputMask
                            mask={'(99)99999-9999'}
                            name='mobile_phone'
                            onChange={handleChange}
                            value={data.mobile_phone}
                        >
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label='Número celular'
                                type='text'
                                fullWidth
                                name='mobile_phone'
                            />
                        </ReactInputMask> */}

                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Cargo'
                        type='text'
                        fullWidth
                        name='role'
                        value={data.role}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Setor'
                        type='text'
                        fullWidth
                        name='sector'
                        value={data.sector}
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};